import React from "react";
import { Visible } from "util/enhancer";

export enum HeadingTag {
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  h4 = "h4",
  h5 = "h5",
}

type HeadingProps = {
  tabIndex?: number;
  className?: string;
  title: string;
  children?: React.ReactNode;
  size?: number;
  tag?: HeadingTag;
  ariaLabel?: string;
};

export const Heading = ({
  tabIndex,
  title,
  children,
  className = "",
  size = 1,
  tag = HeadingTag.h1,
  ariaLabel = "",
}: HeadingProps) => {
  const headingClassName = `zb-heading${size} ${className}`;

  const Header = () => {
    switch (tag) {
      case HeadingTag.h2:
        return (
          <h2
            className={headingClassName}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          >
            {title}
          </h2>
        );
      case HeadingTag.h3:
        return (
          <h3
            className={headingClassName}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          >
            {title}
          </h3>
        );
      case HeadingTag.h4:
        return (
          <h4
            className={headingClassName}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          >
            {title}
          </h4>
        );
      case HeadingTag.h5:
        return (
          <h5
            className={headingClassName}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          >
            {title}
          </h5>
        );
      default:
        return (
          <h1
            className={headingClassName}
            tabIndex={tabIndex}
            aria-label={ariaLabel}
          >
            {title}
          </h1>
        );
    }
  };

  return (
    <>
      <Header />
      {children && <div className="mb-1">{children}</div>}
    </>
  );
};

export const VisibleHeading = Visible(Heading);
